module.exports = __webpack_public_path__ + "img/intro13.31b16978.jpg";